import React, { useContext } from "react";
import { FaRulerVertical, FaAnchor, FaExclamationTriangle, FaDiagnoses } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./scaf.jpg";

const WorkingAtHeight: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/height-safety');
    } else {
      navigate('/login', { state: { from: '/booking/height-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Critical Risk</span>
          <h1 className="hero-title">Working at Height</h1>
          <p className="hero-subtitle">
            Gravity never takes a day off. Comprehensive training on ladders,
            scaffolds, and active fall arrest systems.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">When is Fall Protection Needed?</h2>
              <p className="article-text">
                General Industry requires protection at 4 feet. Construction requires it at 6 feet.
                Scaffolding requires it at 10 feet. Regardless of height, if working over dangerous equipment,
                protection is mandatory.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The ABCs of Fall Arrest</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Anchorage:</strong> Must support 5,000 lbs per worker.</li>
                  <li><strong>Body Support:</strong> Full body harness (distributes force).</li>
                  <li><strong>Connectors:</strong> Lanyards with shock absorbers to limit arrest force.</li>
                  <li><strong>Decent/Rescue:</strong> Plans to retrieve a suspended worker quickly.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Ladder Safety</h2>
              <p className="article-text">
                The 3-point contact rule applies (two hands, one foot, or two feet, one hand).
                Extend extension ladders 3 feet above the landing surface. Use the 4:1 ratio for angle setup.
                Never stand on the top rung.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Suspension Trauma</h2>
              <p className="article-text">
                Hanging in a harness can cause blood pooling in legs, leading to organ failure or death
                in under 30 minutes. Use trauma straps (relief steps) to stand up in the harness while waiting
                for rescue.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Checklist</h4>
              <ul className="key-list">
                <li><FaAnchor className="check-icon" /> Inspect Anchors</li>
                <li><FaRulerVertical className="check-icon" /> 3-Point Control</li>
                <li><FaExclamationTriangle className="check-icon" /> Pendulum Effect</li>
                <li><FaDiagnoses className="check-icon" /> Rescue Plan Ready</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Save Lives</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Height safety certification is mandatory for site access.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WorkingAtHeight;
